import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IUserModel } from 'src/app/core/models/masters/user-master.model';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { ValidationsComponent } from 'src/app/shared/validations/validations.component';
import { GlobalProperties } from 'src/app/global/global-properties';

@Component({
  selector: 'app-tax-amount-popup',
  templateUrl: './tax-amount-popup.component.html',
  styleUrls: ['./tax-amount-popup.component.css']
})
export class TaxAmountPopupComponent implements OnInit {

  displayedColumns: string[] = ['tax_parameter_name', 'tax_rate', 'base_amount', 'tax_amount',];
  dataSource: any = [];
  local_data: any;
  constructor(public dialogRef: MatDialogRef<ValidationsComponent>, dialog: MatDialog, private agenericRepository: GenericService<IUserModel>,
    @Inject(MAT_DIALOG_DATA) public data: any, router: Router) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {
    if (this.local_data && this.local_data.taxCode) {
      this.getTaxDetails(this.local_data.taxCode);
    }
  }

  getTaxDetails(taxCode: string) {
    let url = GlobalProperties._apiUrlSap + `SalesTaxCodes('${taxCode}')`;
    this.agenericRepository.GetAPI(url).subscribe((res: any) => {
      this.local_data.taxName = res.Name
      this.local_data.taxCode = res.Code
      if (res && res.SalesTaxCodes_Lines) {
        this.dataSource = res.SalesTaxCodes_Lines.map((line: any) => {
          let baseAmount = this.local_data.baseAmount || 0;
          let taxAmount = (baseAmount * line.EffectiveRate) / 100;
          return {
            tax_parameter_name: line.STACode,
            tax_rate: line.EffectiveRate,
            base_amount: baseAmount,
            tax_amount: taxAmount
          };
        });
      }
    });
  }

  getTotalTaxAmount() {
    return this.dataSource.reduce((acc: number, row: any) => acc + (row.tax_amount || 0), 0);
  }

}
